'use strict';
var toInteger = require('./$.to-integer')
  , defined   = require('./$.defined');

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.string-repeat.js
 ** module id = 111
 ** module chunks = 0
 **/